/**
 * Target configuration for mission RAYONNER
 * Allows setting target medias and platforms for visibility
 */
import React, { useState } from 'react';
import { Box, Typography, TextField, Chip, FormControl, InputLabel, Select, MenuItem, OutlinedInput } from '@mui/material';
import { colors } from '../../styles/colors';

const PLATFORM_OPTIONS = ['facebook', 'instagram', 'twitter', 'linkedin', 'news', 'web', 'youtube'];

const TargetRayonner = ({ config = {}, onChange, missionColor }) => {
  const [mediaInput, setMediaInput] = useState('');
  const medias = config.medias || [];
  const platforms = config.platforms || [];

  const handleAddMedia = (e) => {
    if (e.key === 'Enter' && mediaInput.trim()) {
      e.preventDefault();
      const updated = [...medias, mediaInput.trim()];
      onChange({ ...config, mission: 'rayonner', medias: updated, platforms });
      setMediaInput('');
    }
  };

  const handleRemoveMedia = (idx) => {
    const updated = medias.filter((_, i) => i !== idx);
    onChange({ ...config, mission: 'rayonner', medias: updated, platforms });
  };

  const handlePlatformsChange = (e) => {
    onChange({ ...config, mission: 'rayonner', medias, platforms: e.target.value });
  };

  return (
    <Box sx={{ p: 2, borderLeft: `3px solid ${missionColor}`, borderRadius: 2, bgcolor: colors.ivory }}>
      <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontSize: '0.82rem', fontWeight: 600, color: colors.charcoal, mb: 1.5 }}>
        Ciblage Rayonner
      </Typography>

      <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontSize: '0.75rem', color: colors.textMed, mb: 0.5 }}>
        Medias cibles (Entree pour ajouter)
      </Typography>
      <TextField
        fullWidth
        size="small"
        placeholder="Ex: Forbes Afrique, Financial Afrik..."
        value={mediaInput}
        onChange={(e) => setMediaInput(e.target.value)}
        onKeyPress={handleAddMedia}
        sx={{ mb: 1 }}
      />
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
        {medias.map((m, idx) => (
          <Chip key={idx} label={m} size="small" onDelete={() => handleRemoveMedia(idx)} sx={{ height: 24, fontSize: '0.72rem', fontFamily: '"DM Sans", sans-serif' }} />
        ))}
      </Box>

      <FormControl fullWidth size="small">
        <InputLabel>Plateformes cibles</InputLabel>
        <Select
          multiple
          value={platforms}
          onChange={handlePlatformsChange}
          input={<OutlinedInput label="Plateformes cibles" />}
          renderValue={(selected) => selected.join(', ')}
        >
          {PLATFORM_OPTIONS.map((p) => (
            <MenuItem key={p} value={p} sx={{ textTransform: 'capitalize' }}>{p}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default TargetRayonner;
